/** Whether a slot matches the currently selected slot by start time and provider. */
export const isSlotSelected = (
  slot: AppointmentSlot,
  selectedSlot?: ProviderAppointmentSlot,
): boolean =>
  slot.startTime === selectedSlot?.startTime &&
  slot.providerId === selectedSlot?.providerId;
